import compose from 'utils/composeEnhancer'
import useFooter from './useFooter'

export default compose(
  useFooter
)
